/* Brief functionality blurbs per module — rendered next to
   module names in the overview cards. Kept terse (one short
   phrase) so bullets stay readable in the mobile sheet. */

export const MODULE_DESCRIPTIONS = {
  Dashboard:   { en: "alerts + daily summary",              ar: "تنبيهات وملخّص يومي" },
  Execution:   { en: "unified task board with SLA tracking", ar: "لوحة مهام موحّدة مع تتبّع SLA" },
  Projects:    { en: "long-running initiatives + budgets",   ar: "مبادرات طويلة المدى وميزانياتها" },
  SmartHome:   { en: "devices, cameras & scenes",            ar: "أجهزة وكاميرات ومشاهد" },

  Income:      { en: "realised + unrealised revenue",        ar: "الدخل المحقّق وغير المحقّق" },
  Expenses:    { en: "approval flow + recurring entries",    ar: "سير الاعتماد والقيود المتكرّرة" },
  Reports:     { en: "P&L + budget vs. actual",              ar: "قائمة الدخل والميزانية مقابل الفعلي" },
  Investments: { en: "holdings, liabilities, interest alerts", ar: "أصول والتزامات وتنبيهات الفوائد" },

  Household:   { en: "grocery requests & routines",          ar: "طلبات البقالة والروتين اليومي" },
  Facility:    { en: "repairs and preventive schedules",     ar: "إصلاحات وجداول وقائية" },
  Fleet:       { en: "vehicles, drivers, service intervals", ar: "مركبات وسائقون وفترات صيانة" },
  Staff:       { en: "roles, leaves, loans, payslips",       ar: "أدوار وإجازات وقروض وكشوف رواتب" },
  Transport:   { en: "schedule driver trips",                ar: "جدولة رحلات السائق" },
  Menu:        { en: "weekly meal cycles with voting",       ar: "قوائم أسبوعية مع تصويت" },
  Suppliers:   { en: "vendor directory + contract alerts",   ar: "دليل موردين وتنبيهات عقود" },

  AIWorkspace: { en: "in-app AI assistant",                  ar: "مساعد ذكاء اصطناعي داخل التطبيق" },
  Files:       { en: "document vault with tags",             ar: "خزينة مستندات بوسوم" },
  Calendar:    { en: "meetings + deadlines",                 ar: "اجتماعات ومواعيد" },
};
